import services from 'utils/mockAdapter';
// user list
const DocsImported = [
    {
        docname: 'User Manual '
    },
    {
        docname: 'Technical Dodument '
    },
    {
        docname: 'Installation Guide'
    }
];
// ==============================|| MOCK SERVICES ||============================== //
services.onGet('/api/manufacturers/docs/list').reply(200, { DocsImported });
